var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"states-list"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[(_vm.isMounted)?_c('vx-card',[_c('div',{attrs:{"id":"container"}})]):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }